import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';
import Typed from './Typed';

import coverPlay from '../resources/images/play.png';
import coverBg from '../resources/images/cover-background.jpg';
import close from '../resources/images/icon-close.svg';

const CoverStyle = styled.div`
	position: static;
    margin-bottom: 6.25rem;
    
	.typed-cursor {
		color: #83F5F8;
	}
	h1 {
	
		@media screen and (min-width: 64em) {
		    font-size: 50px; 
	    }
		@media screen and (max-width: 63.9375em) {
	        font-size: 40px; 
	    }
		@media screen and (max-width: 39.9375em) {
		    font-size: 28px; 
	    }
		    
		margin-left: auto;
		margin-right: auto;
		margin-top: 10px;
		max-width: 950px;
		
		opacity: 0;
		transform: translateY(30px) scaleY(1.1);
		transition: opacity 1500ms ease, transform 1500ms ease;
		
		&.active {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
		
		.regular {
			font-weight: 400;
		}
		.cover-typed {
			font-weight: 700;
		}
	}
	.caption {
		max-width: 700px;
		margin: auto;
		opacity: 0;
		font-size: 1rem;;
		transform: translateY(20px) scaleY(1.1);
		transition: opacity 1000ms ease, transform 1000ms ease;
	    margin-bottom: 1rem;
		
		&.active {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}
	.row {
		position: relative;
	}
	
	@keyframes pulse {
		0% { transform: scale(1); opacity: 1; }
		50% { transform: scale(0.9); opacity: 0.8; }
		100% { transform: scale(1); opacity: 1; }
	}
	
	.cover-playWrapper {
		@media screen and (min-width: 64em) {
		    height: 162px;
		    width: 162px; 
	    }
		@media screen and (max-width: 63.9375em) {
		    height: 162px;
		    width: 162px; 
	    }
		@media screen and (max-width: 39.9375em) {
		    height: 120px;
		    width: 120px; 
	    }
		margin: auto;
		transition: 500ms ease;
		&:hover {
			transition: 200ms ease;
			transform: scale(1.1);
		}
	}
	
	.cover-play {
		@media screen and (min-width: 64em) {
		    height: 162px;
		    width: 162px; 
	    }
		@media screen and (max-width: 63.9375em) {
		    height: 162px;
		    width: 162px; 
	    }
		@media screen and (max-width: 39.9375em) {
		    height: 120px;
		    width: 120px; 
	    }
		margin: auto;
		background-position-x: 50%;
        background-position-y: center;
        background-repeat: no-repeat;
        background-size: contain;
		cursor: pointer;
		animation: pulse 2s infinite;
		
		&:hover {
			transform: scale(1);
			animation-play-state: paused;
		}
	}
	
	.cover-content {
		// position: absolute;
		// top: 0;
		// width: 100%;
		// margin-top: rem-calc(200px);
		margin-top: 12.5rem;
	}
	
	.cover-background {
		height: 100vh;
		// margin-bottom: 200px;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		background-position-x: 50%;
        background-position-y: center;
        background-repeat: no-repeat;
        background-size: cover;
		
		// transform: scale(2);
		// transform-origin: top left;
		// opacity: 0.8;
		
		opacity: 0;
		// transform: translateY(30px) scale(1.05);
		transition: opacity 2000ms ease;
		
		&.active {
			opacity: 1;
			// transform: translateY(0) scale(1);
		}
	}
	
	.cover-background::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0
		width: 100%;
		height: 100px;
		// background-image: linear-gradient(-180deg, rgba(8, 18, 23, 0.00) 0%, #081217 100%);
		background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
	}
	
	.buttonCaption {
		display: block;
		font-size: 0.9rem;
        margin-top: 0.1rem;
        color: #BDBDBD;
        font-weight: 700;
        text-decoration: underline;
	}
`;

const MovieStyle = styled.div`
		background-color: #000;
		z-index: 99;
		height: 100vh;
		width: 100vw;
	    left: 0;
		top: 0; 
		position: fixed;
		opacity: 0;
		visibility: hidden;
		transition: opacity 500ms ease, visibility 500ms ease;
		
		&.active {
			opacity: 1;
			visibility: visible;
		}
		
		.movie-close {
			width: 34px;
			height: 34px;
			background-position-x: 50%;
	        background-position-y: center;
            background-repeat: no-repeat;
	        background-size: contain;
			right: 37px;
			top: 20px;
			position: absolute;
			cursor: pointer;
		}
		
		.movie-maxWidth {
			width: 100%;
			max-width: 1000px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			@media (max-width: 800px) and (min-aspect-ratio: 1/1) {
				width: 70%;
			}
		}
		
		.movie-wrapper {
			width: 100%;
			padding-bottom: 56.25%;
			padding-top: 25px;
			
			iframe {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		}
`;

class Cover extends Component {

	constructor(props) {
		super(props);

		this.state = {
			showMovie: false
		};

		this.toggleMovie = this.toggleMovie.bind(this);
	}

	toggleMovie() {
		this.setState(prevState => ({
			showMovie: !prevState.showMovie
		}));
	}

	render() {
		return (
			<CoverStyle>
				<div className="cover-background active" id="cover-background" style={{ backgroundImage: `url(${coverBg})` }} />
					<div className="cover-content">
						<div className="row text-center">
							<div className="columns medium-10 small-centered">
								<div className="cover-playWrapper">
									<div className="cover-play" style={{ backgroundImage: `url(${coverPlay})` }} onClick={ this.toggleMovie } role="button"/>
								</div>
								{ this.state.showMovie &&
									<MovieStyle className='active'>
										<div className="movie-close" style={{ backgroundImage: `url(${close})` }} onClick={ this.toggleMovie } role="button"/>
										<div className="movie-maxWidth">
											<div className="movie-wrapper">
												<iframe src="https://www.youtube-nocookie.com/embed/4Xn72TfhQck?rel=0&amp;showinfo=0" frameBorder="0" allowFullScreen />
											</div>
										</div>
									</MovieStyle>
								}
								<h1 className="active">
									<span className="regular">{ this.props.cover.typedRegular } </span>
									<Typed  className="cover-typed"
											strings={ this.props.cover.typed }
											typeSpeed={100}
											backSpeed={50}
											backDelay={2500}
											loop />
								</h1>
								<p className="caption active">{ this.props.cover.ctrDescription }</p>
								{/*<Link className="button button--big" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/ico`}>{ this.props.cover.joinICO }</Link>
								<a className="buttonCaption" target="_blank" href="/files/ctr_whitepaper.pdf">{ this.props.cover.readWhitepaper }</a>*/}
							</div>
						</div>
					</div>
			</CoverStyle>
		)
	}
}

export default withRouteData(Cover)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Cover.js